import {
  DELETE_TOBA,
  FAILED_TO_DELETE_TOBA,
  FAILED_TO_GET_TOBAS, FAILED_TO_GET_VALID_TOBAS,
  FAILED_TO_RECEIVE_TOBA_BY_ID,
  GET_TOBA_BY_ID,
  GET_TOBAS,
  GET_VALID_TOBAS,
  RECEIVE_ALL_TOBAS, RECEIVE_ALL_VALID_TOBAS,
  RECEIVE_DELETE_TOBA_RESPONSE,
  RECEIVE_TOBA_BY_ID
} from "./index";

//action that fetches a TOBA by id
export function getTobaById(tobaId) {
    return {
        type: GET_TOBA_BY_ID,
        payload: tobaId
    }
}

//action that receives toba by id
export function receiveTobaById(toba) {
    return {
        type: RECEIVE_TOBA_BY_ID,
        payload: toba
    }
}

//action that receives failed response getting toba by id
export function failedToReceiveTobaById(response) {
    return {
        type: FAILED_TO_RECEIVE_TOBA_BY_ID,
        payload: response
    }
}

//action that requests delete toba by id
export function deleteToba(tobaId) {
    return {
        type: DELETE_TOBA,
        payload: tobaId
    }
}

//action that receives delete toba response
export function receiveDeleteTobaResponse(response) {
    return {
        type: RECEIVE_DELETE_TOBA_RESPONSE,
        payload: response
    }
}

//action that receives failed response from deleting toba
export function failedToDeleteToba(response) {
    return {
        type: FAILED_TO_DELETE_TOBA,
        payload: response
    }
}

//action that requests all tobas
export function getTobas(parameters) {
    return {
        type: GET_TOBAS,
        payload: parameters
    }
}

//action that receives all tobas
export function receiveAllTobas(response) {
    return {
        type: RECEIVE_ALL_TOBAS,
        payload: response
    }
}

//action that received error from getting the tobas
export function failedToGetTobas(response) {
    return {
        type: FAILED_TO_GET_TOBAS,
        payload: response
    }
}

//action that requests all tobas
export function getValidTobas(parameters) {
    return {
        type: GET_VALID_TOBAS,
        payload: parameters
    }
}

//action that receives all tobas
export function receiveAllValidTobas(response) {
    return {
        type: RECEIVE_ALL_VALID_TOBAS,
        payload: response
    }
}

//action that received error from getting the tobas
export function failedToGetValidTobas(response) {
    return {
        type: FAILED_TO_GET_VALID_TOBAS,
        payload: response
    }
}

